import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';
import { baseSoundURL } from '../../config';
import { parseMonitorResponse } from '../../utils/QueuePage/parseMonitorResponse';

export type QueueVideoPlaylistRespType = {
  video: VideoType[];
};

type VideoType = {
  fileId: number;
  order: number;
  filePath: string;
};

export const useGetQueueVideoPlaylist = (setVideoPlaylist: (playlist: string[]) => void) => {
  const {
    data: queueVideoPlaylistResp,
    isFetching: isLoadingQueueVideoPlaylist,
    isSuccess: isQueueVideoPlaylistRecieved
  } = useQuery(
    ['QueueVideoPlaylist', getMonitorToken()],
    async () => {
      const { data } = await axios.get(
        MonitorQueueAPI.getQueueVideoPlaylist,
        queueScreenHeaders()
      );
      return parseMonitorResponse<QueueVideoPlaylistRespType>(data);
    },
    {
      onSuccess: (data) =>
        setVideoPlaylist(data.video.map((e) => `${baseSoundURL}${e.filePath}`)),
      isDataEqual: (prev, next) =>
        JSON.stringify(prev?.video) === JSON.stringify(next?.video),
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      staleTime: 15000,
      refetchOnWindowFocus: false
    }
  );

  return { queueVideoPlaylistResp, isLoadingQueueVideoPlaylist, isQueueVideoPlaylistRecieved };
};
